export const ACCESS_TOKEN = 'is_login';

export const BACKURL = 'https://admkeserv.com';